export class assistedTransferService {
    constructor(params) {
        this.SingletonWebSocket = params.SingletonWebSocket;
        this.SingletonSharedData = params.SingletonSharedData;
        this.StateRule = params.StateRule;
    }
    assistedDialNumber(phone) {
        const action = "assistedDialNumber";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            if (!(/^\d+$/.test(phone)) && (typeof onError === 'function')) {
                const error = { code: 8, message: "The phone should only contain numbers" }
                onError(error);
                return;
            }
            const message = {
                action,
                client: "integration",
                phone: phone
            }
            this.SingletonWebSocket.send(message);
        }
    }
    assistedDialACD(idAcd) {
        const action = "assistedDialACD";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                action,
                client: "integration",
                id: idAcd
            }
            this.SingletonWebSocket.send(message);
        }
    }
    assistedDialAgent(extAgent) {
        const action = "assistedDialAgent";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                action,
                client: "integration",
                id: extAgent
            }
            this.SingletonWebSocket.send(message);
        }
    }
    assistedXFerUseMainCall() {
        const action = "UseMainCall";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = { client: "integration", action }
            this.SingletonWebSocket.send(message);
        }
    }
    assistedXFerUseSecondCall() {
        const action = "UseSecondCall";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = { client: "integration", action }
            this.SingletonWebSocket.send(message);
        }
    }
    assistedXFerHangUP() {
        const action = "AssistedTransferCallHangUp";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            }
            this.SingletonWebSocket.send(message);
        }
    }
    assistedXFerTransferCalls() {
        const action = "TransferAssistedCall";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            }
            this.SingletonWebSocket.send(message);
        }
    }
    assistedXFerDropFirstCall() {
        const action = "DropFirstCall";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            }
            this.SingletonWebSocket.send(message);
        }
    }
    assistedXFerDropSecondCall() {
        const action = "DropSecondCall";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            }
            this.SingletonWebSocket.send(message);
        }
    }
    assistedXFerMakeConference() {
        const action = "MakeConference";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            }
            this.SingletonWebSocket.send(message);
        }
    }
    assistedXFerLeaveConference() {
        const action = "LeaveConference";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            }
            this.SingletonWebSocket.send(message);
        }
    }
}


// WEBPACK FOOTER //
// ./src/Services/assistedTransferService.js